import { validarRespuesta } from '../Services/crypto';


export const PrivateInterceptorsPR = async(URL, method, body = undefined) => {
    let respuesta = null;
    const promesa = await fetch(`${process.env.REACT_APP_API_URLPR}/${URL}?${Date.now()}`, { 
        method: method,
        headers: {
            "Content-Type": "application/json",
            'x-access-token': localStorage.getItem(process.env.REACT_APP_StorageToken)
        },
        body: JSON.stringify(body)
    })

    await promesa.json()
        .then(function (res) {
            // console.log(res);
            // alert('stop')
            validarRespuesta(res);
            respuesta =  res.data;
        })
        .catch((error) => {
            respuesta =  {error: error};
            console.error(respuesta);
        })
        return respuesta;
}